<div
  fxLayout="column"
  class="height-100">

  <!-- Toolbar -->
  <div>
    <mat-toolbar fxLayout="row">
      <!-- Close -->
      <span fxFlex fxLayoutAlign="start center">
        <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="close()" type="button">
          <mat-icon *ngIf="!media.isActive('lt-sm')" svgIcon="close"></mat-icon>
          <mat-icon *ngIf="media.isActive('lt-sm')" svgIcon="arrow-left"></mat-icon>
        </button>
      </span>

      <!-- Detail Title -->
      <span 
        fxLayout="row" 
        fxLayoutAlign="center center"
        [class.compact-header-text]="media.isActive('lt-sm')"
        fxFlex="noshrink">        
        {{ 'LABEL_DETAIL' | translate: {type: type} }}
      </span>    
      
      <!-- Edit -->
      <span fxFlex fxLayoutAlign="end center">
        <!-- <button 
          mat-icon-button 
          (click)="modify()" 
          [matTooltip]="'LABEL_EDIT' | translate"
          *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.update)"
          >
          <mat-icon svgIcon="pencil"></mat-icon>
        </button> -->
      </span>
    </mat-toolbar>
  </div>

  <div class="height-100 width-100">
    <mat-tab-group dynamicHeight="false" class="mat-tab-group-md-width" (selectedTabChange)="tabChanged($event)" [(selectedIndex)]="selectedTabIndex">
      <!-- Detail Data -->
      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{ 'LABEL_DETAILS' | translate}}</span>
        </ng-template>
        
        <mat-list>
          <mat-list-item 
            class="detail-list-height"
            *ngFor="let key of detailKeys">
            <h3 matLine class="list-data">
              <span class="word-wrap">
                <!-- {{ detailData[key] }} -->
                {{ (key == 'is_active' || key == 'terminal_is_registered') ? (helper.displayFields(detailData, key) | translate) : helper.displayFields(detailData, key, moduleCode, displayMode) }}
              </span>
            </h3>
            <p matLine class="list-label">
              {{ helper.displayDetailLabel(key, moduleCode, displayMode) | translate }}
            </p>
          </mat-list-item>
        </mat-list>
      </mat-tab>

      <!-- Chain-Company Handling Fee -->
      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{ 'LABEL_HANDLING_FEES' | translate}}</span>
        </ng-template>
        
        <div class="height-100">
          <div *ngIf="handling_fees.length" class="width-100 overflow-auto">
            <table mat-table [dataSource]="handling_fees">
              <!-- Actions -->
              <ng-container matColumnDef="actions" sticky>
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element">
                  <div fxLayout fxLayoutAlign="center center"> 
                    <button *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.update)" mat-icon-button (click)="openHandlingFeeModal(element)" [matTooltip]="'LABEL_EDIT' | translate">
                      <mat-icon svgIcon="pencil"></mat-icon>
                    </button> 
                  </div>
                </td>
              </ng-container>
      
              <!-- company -->
              <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef>{{'TBL_HDR_COMPANY' | translate}}</th>
                <td mat-cell *matCellDef="let element"> 
                  {{ element?.company?.description }}
                </td>
              </ng-container>
      
              <!-- handling_fee_value -->
              <ng-container matColumnDef="handling_fee_value">
                <th mat-header-cell *matHeaderCellDef>{{'TBL_HDR_HANDLING_FEE' | translate}}</th>
                <td mat-cell *matCellDef="let element"> 
                  {{ element?.handling_fee_value }}
                </td>
              </ng-container>  
      
              <!-- is_active -->
              <ng-container matColumnDef="is_active">
                <th mat-header-cell *matHeaderCellDef>{{'TBL_HDR_STATUS' | translate}}</th>
                <td mat-cell *matCellDef="let element"> 
                  {{ helper.displayFields(element, 'is_active', null) | translate }}
                </td>
              </ng-container>  
      
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>

          <div *ngIf="!handling_fees?.length" fxFlex fxLayout="column" fxLayoutAlign="center center">
            <mat-icon svgIcon="information-outline" class="size-48"></mat-icon>
            <span class="mat-body" [class.compact-header-text]="media.isActive('lt-sm')">
              {{ 'LABEL_NO_DATA' | translate}}
            </span>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

    <button mat-mini-fab color="primary" class="mini-fab-button" (click)="modify()" *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.update) && selectedTabIndex == 0">
      <mat-icon svgIcon="pencil" [matTooltip]="'LABEL_EDIT_TYPE' | translate : {type: 'LABEL_CHAIN' | translate}"></mat-icon>
    </button>

    <button mat-mini-fab color="primary" class="mini-fab-button" (click)="openHandlingFeeModal({})" *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.add) && authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.update) && selectedTabIndex != 0">
      <mat-icon svgIcon="plus" [matTooltip]="'LABEL_ADD_NEW' | translate : {type: ('LABEL_HANDLING_FEE' | translate)}"></mat-icon>
    </button>
  </div>

</div>